// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fias-search-wrapper {
  position: relative;
  width: 100%;
}

.input-container {
  position: relative;
}

.fias-input {
  width: 100%;
  padding: 0.5rem;
  border: 1px solid #ccc;
  border-radius: 4px;
}

.clear-button {
  position: absolute;
  right: 8px;
  top: 50%;
  transform: translateY(-50%);
  background: none;
  border: none;
  cursor: pointer;
  font-size: 1.2rem;
  color: #666;
}

.dropdown-results {
  position: absolute;
  /* width: calc(100% - 210px); */
  max-height: 200px;
  overflow-y: auto;
  border: 1px solid #ccc;
  border-radius: 4px;
  background: white;
  z-index: 1000;
  margin-top: 4px;
}

.result-item {
  padding: 8px 12px;
  cursor: pointer;
  transition: background 0.2s;
}

.result-item:hover {
  background: #f0f0f0;
}

.loading-message,
.no-results {
  padding: 8px 12px;
  color: #666;
  font-style: italic;
}
`, "",{"version":3,"sources":["webpack://./src/ui/custom-controls/styles/FiasSearchInput.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,2BAA2B;EAC3B,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,+BAA+B;EAC/B,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;EAClB,iBAAiB;EACjB,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;EAEE,iBAAiB;EACjB,WAAW;EACX,kBAAkB;AACpB","sourcesContent":[".fias-search-wrapper {\n  position: relative;\n  width: 100%;\n}\n\n.input-container {\n  position: relative;\n}\n\n.fias-input {\n  width: 100%;\n  padding: 0.5rem;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n}\n\n.clear-button {\n  position: absolute;\n  right: 8px;\n  top: 50%;\n  transform: translateY(-50%);\n  background: none;\n  border: none;\n  cursor: pointer;\n  font-size: 1.2rem;\n  color: #666;\n}\n\n.dropdown-results {\n  position: absolute;\n  /* width: calc(100% - 210px); */\n  max-height: 200px;\n  overflow-y: auto;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n  background: white;\n  z-index: 1000;\n  margin-top: 4px;\n}\n\n.result-item {\n  padding: 8px 12px;\n  cursor: pointer;\n  transition: background 0.2s;\n}\n\n.result-item:hover {\n  background: #f0f0f0;\n}\n\n.loading-message,\n.no-results {\n  padding: 8px 12px;\n  color: #666;\n  font-style: italic;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
